import { render, staticRenderFns } from "./ElderlyLessRecord.vue?vue&type=template&id=071755b8&"
import script from "./ElderlyLessRecord.vue?vue&type=script&lang=js&"
export * from "./ElderlyLessRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports